import { useShopwareContext } from "#imports";

async function useCrossSellings() {
  const { apiInstance } = useShopwareContext();
  const { product } = useProduct();

  const hasCrossSellingProducts = computed(() => {
    return product.value?.crossSellings?.find((crossSelling) => crossSelling.active === true);
  });

  const crossSellings = ref([]);

  const loadCrossSellingProducts = async () => {
    if (hasCrossSellingProducts.value) {
      const { data } = await apiInstance.invoke.post(
        `/store-api/product/${product.value.id}/cross-selling`,
      );

      crossSellings.value =
        data?.map((group) => ({
          name: group.crossSelling.name,
          id: group.crossSelling.id,
          crossSelling: group.crossSelling,
          products: group.products,
        })) || [];
    }
  };

  return {
    hasCrossSellingProducts,
    loadCrossSellingProducts,
    crossSellings,
  };
}

export const useCrossSelling = createSharedComposable(useCrossSellings);
